import styled from '@emotion/styled';
import {
  theme,
  media,
  sunriseSemanticTokens,
  fonts,
  pxToRem,
  pxToCssFontSize,
  sunrisePrimitives,
} from '@vfit/shared/themes';

export const TechnologyCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${theme.spacing?.xl};
  align-self: stretch;

  ${media.tablet`
    gap: ${theme.spacing?.lg};
  `}

  ${media.largeDesktop`
    gap: ${theme.spacing?.xl};
  `}
`;

export const TechnologyCardTitleWrapper = styled.div`
  align-self: stretch;
`;

export const TechnologyCardTitle = styled.div`
  display: flex;
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.h4};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-style: normal;
  line-height: ${theme.typography.lineHeight.h4};
  text-align: left;
  margin: 0;
  align-items: center;

  * {
    margin: 0;
  }

  ${media.largeDesktop`
    font-size: ${theme.typography.fontSize.h2};
    line-height: ${theme.typography.lineHeight.h2};
  `}

  &  img {
    display: inline-block;
    width: ${pxToRem(24)};
    height: ${pxToRem(24)};
    margin-left: ${theme.spacing.sm};
    object-fit: cover;
  }
`;

export const TechnologyCardIcon = styled.div`
  display: inline-block;
  width: ${pxToRem(24)};
  height: ${pxToRem(24)};
  margin-left: ${theme.spacing.sm};
  vertical-align: text-bottom;
  border-radius: ${pxToRem(100)};

  img {
    width: 100%;
    height: 100%;
    border-radius: ${pxToRem(100)};
    object-fit: cover;
    margin-bottom: ${theme.spacing?.xs};
  }
`;

export const ConsumerTechCardWrapper = styled.div`
  /* display: flex;
  align-self: flex-start;
  flex-direction: column; */
  display: block;

  & > *:not(:last-child) {
    margin-bottom: ${theme.spacing.lg};
  }

  ${media.largeDesktop`
    & > *:not(:last-child) {
      margin-bottom: ${theme.spacing.xl};
    }
  `}
`;

export const TechContainer = styled.div`
  display: flex;
  flex: 1;
  align-self: center;
  flex-direction: column;
`;

export const TechnologyCardDescription = styled.div`
  color: ${sunriseSemanticTokens.colors.text.primary};
  font-family: ${fonts.vodafone};
  font-size: ${theme.typography.fontSize.body1};
  font-weight: ${theme.typography.fontWeight.regular};
  font-style: normal;
  line-height: ${theme.typography.lineHeight.body1};
  text-align: left;
  margin: 0;

  * {
    margin: 0;
  }
`;

export const ExtraItemListTitle = styled.div`
  margin-bottom: ${pxToRem(35)};
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};
  font-size: ${theme.typography.fontSize.h6};
  line-height: ${theme.typography.lineHeight.h6};
`;

export const TechIcons = styled.div`
  margin-bottom: ${pxToRem(35)};
`;

export const ExtraItemList = styled.div`
  border-spacing: ${pxToRem(10)};
  display: flex;
  gap: ${theme.spacing.md};
`;

export const Title = styled.span`
  align-self: center;
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.extrabold};

  ${media.tablet`
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body2};
  `}

  ${media.largeDesktop`
    font-size: ${theme.typography.fontSize.h6};
    line-height: ${theme.typography.lineHeight.h6};
  `}
`;

export const ItemRow = styled.div`
  font-family: ${theme.typography.fontFamily.primary};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.body2};
  line-height: ${theme.typography.lineHeight.body2};
  font-style: normal;
  width: stretch;
  align-items: center;
  display: flex;
  flex-direction: column;

  ${media.largeDesktop`
    font-size: ${theme.typography.fontSize.body1};
    line-height: ${theme.typography.lineHeight.body1};
  `}
`;

export const BodyContainer = styled.div`
  display: flex;
  gap: ${theme.spacing.xl};
`;

export const BodyGroup = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Body = styled.div`
  align-self: left;
  color: ${sunrisePrimitives.gray900};
  font-family: ${fonts.vodafone};
  font-weight: ${theme.typography.fontWeight.regular};
  font-size: ${theme.typography.fontSize.body3};
  line-height: ${theme.typography.lineHeight.h3};

  margin: 0;
  * {
    margin: 0;
  }

  ${media.largeDesktop`
    font-size: ${theme.typography.fontSize.body2};
  `}
`;

export const ContentItemRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;

  ${media.tablet`
    min-width: ${pxToRem(110)};
  `}

  ${media.largeDesktop`
    min-width: ${pxToRem(54)}
    min-width: ${pxToRem(104)};
  `}
`;

export const ContentRow = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;

  padding: ${pxToRem(8)} ${pxToRem(16)};
  align-items: baseline;
  margin-top: ${theme.spacing.xl};
  gap: ${pxToRem(13)};

  background-color: #f4f4f4;
  border-radius: 100px;

  ${media.tablet`
    width: ${pxToRem(433)};
    gap: ${pxToRem(15)};
    margin-top: ${theme.spacing.lg};
  `}

  ${media.largeDesktop`
    min-width: ${pxToRem(366)};
    max-width: ${pxToRem(433)};
    gap: ${theme.spacing.md};
    margin-top: ${theme.spacing.xl};
  `}
`;

export const ActionIcon = styled.button`
  display: flex;
  border: none;
  padding: 0;
  margin: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  background: ${sunriseSemanticTokens.colors.text.error};
  border-radius: ${pxToRem(100)};
  color: white;
  width: ${pxToRem(26)};
  height: ${pxToRem(26)};
  text-align: center;
  align-items: center;
  justify-content: center;
  ${pxToCssFontSize(26)}
  font-family: ${fonts.light};
  align-self: center;

  &:hover {
    background: ${sunriseSemanticTokens.colors.text.linkHover};
  }

  &:active {
    background: ${sunriseSemanticTokens.colors.brand.primaryActive};
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;

export const ContentTitle = styled.p`
  color: ${sunrisePrimitives.gray900};
  align-self: left;
  font-family: ${fonts.vodafone};
  font-weight: ${theme.typography.fontWeight.bold};
  font-size: ${theme.typography.fontSize.body3};
  line-height: ${theme.typography.lineHeight.h3};
  margin: 0;

  * {
    margin: 0;
  }

  ${media.largeDesktop`
    font-size: ${theme.typography.fontSize.body2};
    line-height: ${theme.typography.lineHeight.body1};  
  `}
`;

